import { CDropdown, CDropdownMenu, CDropdownToggle } from '@coreui/react-pro'
import React from 'react'

export default function ProgressNoteActionButtons({ SignButton, SaveButton, PendingReviewButton }) {
  return (
    <CDropdown className={'note-dropdown'}>
      <SignButton />
      <CDropdownToggle split className="progress-note-billing-summary-split" />
      <CDropdownMenu className="progress-note-billing-summary-dropdown-menu">
        <SaveButton />
        <PendingReviewButton />
      </CDropdownMenu>
    </CDropdown>
  )
}
